(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-bundle-gallery]').forEach((gallery) => {
    gallery.querySelectorAll('[data-bundle-thumb]').forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        const targetName = thumbnail.dataset.target;
        const imageIndex = thumbnail.dataset.imageIndex;
        const groups = targetName === 'ring'
          ? gallery.querySelectorAll('[data-bundle-slides="ring"], [data-bundle-slides="ring-second"]')
          : gallery.querySelectorAll(`[data-bundle-slides="${targetName}"]`);
        groups.forEach((group) => {
          group.querySelectorAll('[data-bundle-slide]').forEach((slide) => {
            slide.classList.toggle('is-active', slide.dataset.imageIndex === imageIndex);
          });
        });
        gallery.querySelectorAll(`[data-bundle-thumb][data-target="${targetName}"]`).forEach((item) => { item.classList.remove('is-active'); item.setAttribute('aria-pressed', 'false'); });
        thumbnail.classList.add('is-active');
        thumbnail.setAttribute('aria-pressed', 'true');
      });
    });
  });
  document.querySelectorAll('[data-bundle-section]').forEach((section) => {
    const form = section.querySelector('[data-bundle-form]');
    const variantData = section.querySelector('[data-ring-variants]');
    if (!form || !variantData) return;
    const variants = JSON.parse(variantData.textContent);
    const selectors = Array.from(form.querySelectorAll('[data-ring-selector]'));
    const submit = form.querySelector('[data-bundle-submit]');
    const message = form.querySelector('[data-bundle-message]');
    const getVariant = (selector) => {
      const values = Array.from(selector.querySelectorAll('[data-ring-option]')).sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)).map((input) => input.value);
      return variants.find((variant) => variant.options.every((value, index) => value === values[index]));
    };
    const validate = () => {
      const chosen = selectors.map(getVariant);
      const available = chosen.every((variant) => variant && variant.available);
      submit.disabled = !available;
      message.textContent = available ? '' : section.dataset.unavailableLabel;
      return available ? chosen : null;
    };
    form.addEventListener('change', validate);
    validate();
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const chosen = validate();
      if (!chosen) return;
      const quantities = new Map();
      chosen.forEach((variant) => quantities.set(Number(variant.id), (quantities.get(Number(variant.id)) || 0) + 1));
      const burnerVariant = form.querySelector('[data-burner-variant]');
      if (burnerVariant) quantities.set(Number(burnerVariant.value), (quantities.get(Number(burnerVariant.value)) || 0) + 1);
      const items = Array.from(quantities, ([id, quantity]) => ({ id, quantity }));
      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        if (!response.ok) throw new Error();
        window.location.assign(`${window.Shopify.routes.root}checkout`);
      } catch (error) {
        message.textContent = section.dataset.errorLabel;
        submit.disabled = false;
        submit.removeAttribute('aria-busy');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const mainImage = gallery.querySelector('.gallery-main-image');
    if (!mainImage) return;
    gallery.querySelectorAll('[data-gallery-thumb]').forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        mainImage.style.opacity = '0';
        window.setTimeout(() => {
          mainImage.removeAttribute('srcset');
          mainImage.removeAttribute('sizes');
          mainImage.src = thumbnail.dataset.imageUrl;
          mainImage.alt = thumbnail.dataset.imageAlt;
          mainImage.style.opacity = '1';
        }, 140);
        gallery.querySelectorAll('[data-gallery-thumb]').forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
        });
        thumbnail.classList.add('is-active');
        thumbnail.setAttribute('aria-pressed', 'true');
      });
    });
  });

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const form = section.querySelector('[data-product-form]');
    const variantData = section.querySelector('[data-product-variants]');
    if (!form || !variantData) return;
    const variants = JSON.parse(variantData.textContent);
    const groups = Array.from(form.querySelectorAll('[data-option-group]'));
    const idInput = form.querySelector('[data-variant-id]');
    const addButton = form.querySelector('[data-add-button]');
    const addLabel = form.querySelector('[data-add-label]');
    const message = form.querySelector('[data-product-message]');
    const price = section.querySelector('[data-product-price]');
    const locale = document.documentElement.lang;
    const money = new Intl.NumberFormat(locale === 'ar' ? 'ar-AE' : locale, { style: 'currency', currency: window.Shopify.currency.active });
    form.addEventListener('change', () => {
      const selections = groups.map((group) => group.querySelector('input:checked')?.value);
      const variant = variants.find((item) => item.options.every((value, index) => value === selections[index]));
      if (!variant) {
        addButton.disabled = true;
        return;
      }
      idInput.value = variant.id;
      price.textContent = money.format(variant.price / 100);
      addButton.disabled = !variant.available;
      addLabel.textContent = variant.available ? section.dataset.buyLabel : section.dataset.soldOutLabel;
    });
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (addButton.disabled) return;
      addButton.disabled = true;
      addButton.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: Number(form.querySelector('[name="quantity"]').value) }] })
        });
        if (!response.ok) throw new Error();
        window.location.assign(`${window.Shopify.routes.root}checkout`);
      } catch (error) {
        message.textContent = section.dataset.errorLabel;
        addButton.disabled = false;
        addButton.removeAttribute('aria-busy');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-showcase"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-checkout-form]').forEach((form) => {
    if (form.dataset.checkoutBound === 'true') return;
    form.dataset.checkoutBound = 'true';
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      const message = form.querySelector('[data-checkout-message]');
      const quantities = new Map();
      form.querySelectorAll('[data-checkout-item]').forEach((input) => {
        const id = Number(input.value);
        quantities.set(id, (quantities.get(id) || 0) + 1);
      });
      const items = Array.from(quantities, ([id, quantity]) => ({ id, quantity }));
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        if (!response.ok) throw new Error();
        window.location.assign(`${window.Shopify.routes.root}checkout`);
      } catch (error) {
        message.textContent = form.closest('[data-error-label]')?.dataset.errorLabel || '';
        message.classList.add('is-error');
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
